import { useQuery } from "@apollo/client";
import { InstallSectionCard } from "../InstallSectionCard";
import { useCompanyPageStore } from "../../../../../../store/companyPageStore";
import {
  INTENSITY_TREND_QUERY,
  IntensityTrendPayload,
} from "../../../../../../legacy/queries/Intensity";
import { IntensityTable } from "./IntensityTable";
import { GridPaginationModel } from "@mui/x-data-grid";
import { useState } from "react";
import Box from "@mui/material/Box";
import { COMPANY_SEARCH_CLIENT } from "../../../../../../utils/consts";

const helpText =
  "Intensity Trend shows a QoQ percentage change of signal (intensity) over a 12-month period. It is useful for getting a longer ranged view of a product at a company based on changes to the intensity (signal strength observed). It will have a theoretical min/max of approx +/-27%.";

export const IntensityTrend = () => {
  const company = useCompanyPageStore((state) => state.company);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });
  const [persistedTotalCount, setPersistedTotalCount] = useState(0);

  const { data, loading } = useQuery<IntensityTrendPayload>(
    INTENSITY_TREND_QUERY,
    {
      context: { clientName: COMPANY_SEARCH_CLIENT },
      variables: {
        hgId: company!.hgId,
        page: paginationModel.page,
        per: paginationModel.pageSize,
      },
      onCompleted: (queryData) => {
        if (queryData?.intensityTrend?.count !== undefined) {
          setPersistedTotalCount(queryData.intensityTrend.count);
        }
      },
    }
  );

  return (
    <InstallSectionCard
      title="Intensity Trend"
      height={700}
      noTitleMargin
      filterKey="INTENSITY_TREND"
    >
      <Box marginTop={3}>
        <IntensityTable
          data={data?.intensityTrend?.data || []}
          loading={loading}
          title="Intensity Trend"
          helpText={helpText}
          highlightText="Intensity Trend"
          count={persistedTotalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>
    </InstallSectionCard>
  );
};
